(ns assemble.assets-page.file-grid.view
  (:require ["@mui/icons-material/BrokenImageOutlined$default" :as BrokenImageOutlined]
            ["@mui/material/Grid$default" :as Grid]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium GridActionsCellItem
                                                GridLogicOperator
                                                isAutogeneratedRow]]
            ["react-dropzone-new" :refer [useDropzone]]
            [assemble.assets-page.upload-modal.db]
            [assemble.component.dropzone :refer [grid-drop-overlay grid-drop-props]]
            [assemble.component.file-tree.hooks :refer [use-active-asset-type]]
            [assemble.component.filter-panel :as filter-panel]
            [assemble.component.move-modal.db :as move-modal.db]
            [assemble.component.table :as table]
            [assemble.resource.asset :as resource]
            [assemble.util :as util]
            [cljs-bean.core :refer [bean]]
            [clojure.string :as str]
            [common.util]
            [common.widgets.data-grid :as dg]
            [common.widgets.status :as status]
            [goog.object :as gobject]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn get-row [value-fn _value row ^js _column ^js _apiRef]
  (value-fn row))

(defn children->ids [children]
  (map :asset-tree/id children))

;; Note: Reagent ratoms may not work properly within these render-*-cell components
(defn render-preview-cell [^js o]
  (let [;; This fn is used as React component from DataGrid, so using
        ;; hooks is safe here.
        [error set-error] (uix/use-state nil)
        {:asset/keys [name thumbnail-url key-url]} (.-row o)
        {:keys [use-thumbnail use-preview icon]} (if (:asset-tree/id (.-row o))
                                                   {:use-thumbnail false
                                                    :icon "folder_open"}
                                                   (util/get-file-type-parameters name))]
    ($ Grid
       {:container true
        :alignContent "center"
        :justifyContent "center"
        :sx #js {:color "grey.40"}}
       (if use-thumbnail
         (if error
           ($ BrokenImageOutlined
              {;; Adjust viewbox to get the icon to use
               ;; smaller part of the box.
               :viewBox "-6 -6 36 36"
               :sx #js {:width 40
                        :height 40
                        :borderRadius "4px"
                        :bgcolor "grey.50"}})
           (case use-preview
             :img ($ :img
                     {:src thumbnail-url
                      :width 40
                      :height 40
                      :onError (fn [_image] (set-error true))
                      :style {:border-radius "4px"}})
             :video ($ :video
                       {:src key-url
                        :preload "metadata"
                        :controls false
                        :autoPlay false
                        :height 40
                        :width 40
                        :onError (fn [_video] (set-error true))})
             ($ Icon
                {:sx #js {:fontSize "3rem"}}
                icon)))
         ($ Icon
            {:sx #js {:fontSize "3rem"}}
            icon)))))

(defn render-url-cell [^js o]
  (let [{:asset/keys [key-url mime-type]} (.-row o)]
    (cond
      (util/unsupported-mime-type? mime-type) ($ :<>
                                                 ($ Icon
                                                    {:sx #js {:mr 1}
                                                     :color "error"}
                                                    "error")
                                                 "Unsupported file type")
      key-url ($ :<>
                 ($ Tooltip
                    {:placement :bottom
                     :title "Copy to clipboard"}
                    ($ IconButton
                       {:sx #js {:mr 1}
                        :onClick (fn [^js e]
                                   (set! (.-ignore e) true)
                                   (rf/dispatch [:assemble.assets-page/copy-to-clipboard key-url]))}
                       ($ Icon "content_copy")))
                 ($ Link
                    {:href key-url
                     :noWrap true
                     :target "_blank"
                     :onClick (fn [^js e]
                                (set! (.-ignore e) true))}
                    key-url)))))

(defn render-status-state-cell [^js o]
  (when-not (:asset-tree/id (.-row o))
    (let [{:asset/keys [archived]} (.-row o)
          color "grey.40"]
      (when archived
        ($ status/simple {:color color :status "archived"})))))

(defn get-actions [^js o]
  (let [row (.-row o)
        {:asset/keys [id archived]} row]
    (if (nil? (:asset-tree/id row))
      #js [($ GridActionsCellItem
              {:onClick (fn [_]
                          (rf/dispatch [::move-modal.db/open {:item-id (:asset/id row)
                                                              :item-name (:asset/name row)
                                                              :folder-id (:asset/asset-tree-id row)}]))
               :label "Move asset"
               :showInMenu true})
           ($ GridActionsCellItem
              {:onClick (fn [_]
                          (rf/dispatch [:assemble.assets-page/set-current-file row]))
               :label "Rename asset"
               :showInMenu true})
           ($ GridActionsCellItem
              {:onClick (fn [_]
                          (js/Promise.
                           (fn [resolve reject]
                             (rf/dispatch [::resource/archive-asset resolve reject id (not archived)]))))
               :label (if archived "Unarchive asset" "Archive asset")
               :showInMenu true})]
      #js [($ GridActionsCellItem
              {:onClick (fn [_]
                          (rf/dispatch [:assemble.assets-page/set-current-folder row]))
               :label "Rename folder"
               :showInMenu true})
           ($ GridActionsCellItem
              {:onClick (fn [_]
                          (rf/dispatch [::move-modal.db/open {:item-id (:asset-tree/id row)
                                                              :item-name (:asset-tree/name row)
                                                              :folder-id (:asset-tree/parent-id row)
                                                              :children-ids (children->ids (:children row))
                                                              :move-folder? true}]))
               :label "Move folder"
               :showInMenu true})])))

(defn get-font-actions [^js o]
  (let [row (.-row o)
        {:asset/keys [id]} row]
    (if (nil? id)
      #js [($ GridActionsCellItem
              {:onClick (fn [_]
                          (rf/dispatch [:assemble.assets-page/set-current-font-family
                                        (second (clojure.string/split (.-id o) #"/"))]))
               :label "Rename font family"
               :showInMenu true})]
      #js [])))

(defn asset-columns [asset-type]
  #js [#js {:field "preview"
            :headerName ""
            :width 64
            :align "center"
            :renderCell render-preview-cell
            :sortable false
            :filterable false}
       #js {:field "name"
            :headerName "Name"
            :minWidth 200
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (or (:asset/name row)
                               (:asset-tree/name row)))
            :renderCell (fn [^js o]
                          (let [row (.-row o)]
                            (if (some? (:asset/name row))
                              (util/basename (:asset/name row))
                              (:asset-tree/name row))))}
       #js {:field "type"
            :headerName "Type"
            :width 100
            ;; NOTE: This break the sorting because the value is just "image" or "audio"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (if (= :logos asset-type)
                             (:asset/mime-type row)
                             (some-> (util/extension->group (util/file-extension (:asset/name row))) name)))
            :renderCell (fn [^js o]
                          (:asset/mime-type (.-row o)))}
       #js {:field "url"
            :headerName "URL"
            :minWidth 200
            :flex 1
            :filterable false
            :valueGetter (partial get-row :asset/key-url)
            :renderCell render-url-cell}
       #js {:field "status"
            :headerName "Status"
            :width 110
            ;; Consider folders not archived
            :valueGetter (partial get-row #(:asset/archived % false))
            :renderCell render-status-state-cell}
       #js {:field "creationDate"
            :headerName "Creation date"
            :minWidth 140
            ;; FIXME: formatting date here is incorrect
            :valueGetter (comp #(when % (common.util/format-iso-string %))
                               (partial get-row :asset/created-at))}
       #js {:field "actions"
            :type "actions"
            :column-type "actions"
            :width 16
            :getActions get-actions}])

(defn render-weight-cell [^js o]
  (let [{:asset/keys [mime-type]} (.-row o)]
    (if (util/unsupported-mime-type? mime-type)
      ($ :<>
         ($ Icon
            {:sx #js {:mr 1}
             :color "error"}
            "error")
         "Unsupported file type")
      (util/format-font-weight (.-value o)))))

(def font-columns
  #js [#js {:field "weight"
            :headerName "Weight"
            :minWidth 200
            :flex 1
            :valueGetter (partial get-row (comp :font-weight :asset/metadata))
            :renderCell render-weight-cell}
       #js {:field "style"
            :headerName "Style"
            :minWidth 200
            :flex 1
            :valueGetter (partial get-row (comp :font-style :asset/metadata))
            :renderCell (fn [^js o] (util/format-font-style (.-value o)))}
       #js {:field "actions"
            :type "actions"
            :column-type "actions"
            :width 16
            :getActions get-font-actions}])

(defn get-row-node-using-a-hack [row ^js apiRef]
  (let [;; GRID_ID_AUTOGENERATED is part of MUI internals, was not meant to be accessed.
        ;; But we need to use it, so here we go with this very dirty JS hack.
        GRID_ID_AUTOGENERATED (first (js/Object.getOwnPropertySymbols row))
        id (gobject/get row GRID_ID_AUTOGENERATED)
        ^js api (.-current apiRef)]
    (.getRowNode api id)))

(defn fonts-grid-props []
  ;; Grouping is only on premium plan, would be simpler:
  ;; https://mui.com/x/react-data-grid/row-grouping/#initialize-the-row-grouping
  ;; But we can group the data ourselves and use Tree support.
  {:treeData true
   :getTreeDataPath (fn [row] (:path row))
   ;; leafField doesn't work with tree data
   :groupingColDef #js {:hideDescendantCount true
                        :headerName "Name"
                        :minWidth 200
                        :flex 1
                        :valueGetter (fn [_value row ^js _column ^js apiRef]
                                       (if (isAutogeneratedRow row)
                                         (let [rowNode (get-row-node-using-a-hack row apiRef)]
                                           (.-groupingKey rowNode))
                                         (:asset/name row)))}
   :defaultGroupingExpansionDepth 1
   :initialState #js {:sorting #js {:sortModel #js [#js {:field "weight" :sort "asc"}
                                                    #js {:field "style" :sort "desc"}]}}})

(defn on-row-click [^js o ^js event]
  (when (and (not (.-ignore event))
             ;; Clicking on font group rows should be no-op
             (map? (.-row o)))
    (if (:asset-tree/id (.-row o))
      ;; TODO: Also expand the folder on tree?
      (rf/dispatch [:assemble.page.assets.file-tree/set-current-node (:asset-tree/id (.-row o))])
      (rf/dispatch [:assemble.assets-page/set-current-file (.-row o)]))))

(def Toolbar
  (uix/as-react
   (fn [{:keys [quick-filter-props asset-type]}]
     ($ dg/grid-toolbar
        {:quick-filter-props quick-filter-props
         :sx #js {:justifyContent "flex-start"
                  :px 2}}
        (when (= :assets asset-type)
          ($ dg/quick-select-filter
             {:label "Type"
              :field "type"
              :id "type"
              :data-testid "typeFilterSelect"
              :filter-options [{:value "image"
                                :label "Image"}
                               {:value "video"
                                :label "Video"}
                               {:value "audio"
                                :label "Audio"}
                               {:value "model"
                                :label "3D"}]}))
        (when (= :logos asset-type)
          ($ dg/quick-select-filter
             {:id "logo-type"
              :label "Type"
              :field "type"
              :data-testid "typeFilterSelect"
              :filter-options [{:value "image/jpeg"
                                :label "JPG"}
                               {:value "image/png"
                                :label "PNG"}
                               {:value "image/svg+xml"
                                :label "SVG"}
                               {:value "image/gif"
                                :label "GIF"}]}))

        (when (= :fonts asset-type)
          ($ dg/quick-select-filter
             {:id "font-style"
              :label "Style"
              :field "style"
              :data-testid "styleFilterSelect"
              :filter-options (for [[v label] util/font-styles]
                                {:value v
                                 :label label})}))
        (when (= :fonts asset-type)
          ($ dg/quick-select-filter
             {:id "font-weight"
              :label "Weight"
              :field "weight"
              :data-testid "weightFilterSelect"
              :filter-options (for [[v label] util/font-weights]
                                {:value (str v)
                                 :label label})}))

        (when (not= :fonts asset-type)
          ($ dg/quick-select-filter
             {:id "status"
              :label "Status"
              :field "status"
              :data-testid "statusFilterSelect"
              :filter-options [{:value "false"
                                :label "Not archived"}
                               {:value "true"
                                :label "Archived"}]}))))))

(defui file-grid []
  (let [node-id (use-subscribe [:assemble.page.assets.file-tree/current-node-id])
        {:keys [advertiser-id]} (use-subscribe [:url-context])
        asset-type (use-active-asset-type)
        font-view (= :fonts asset-type)

        current-folder (use-subscribe [:assemble.page.assets.file-tree/get-item node-id])

        tree (use-subscribe [:cqrs/get :asset/list-assets])

        fonts-by-node-and-advertiser (use-subscribe [:assemble.resource.asset/fonts-by-node-and-advertiser-id node-id advertiser-id])
        assets-by-node (use-subscribe [:assemble.resource.asset/assets-by-node node-id])
        value (if font-view
                fonts-by-node-and-advertiser
                ;; Only assets have folders, and IF (will not be possible) fonts had folders,
                ;; the grid tree fns would break.
                (into (vec (:children current-folder))
                      assets-by-node))
        dropzone (useDropzone #js {:onDrop #(rf/dispatch [:assemble.assets-page.upload-modal.db/open
                                                          {:files % :asset-type asset-type}])
                                   :noClick true
                                   :noKeyboard true})
        drop-active (.-isDragActive dropzone)]
    ($ Grid
       (merge (grid-drop-props dropzone)
              {:flex "1 1 0%"
               :container true
               :sx #js {:position "relative"
                        :minWidth "40%"}})
       ($ :input (bean (.getInputProps dropzone)))
       ($ table/NoRowsContextProvider
          {:value {:asset-type asset-type
                   :drop-active drop-active
                   :on-open (.-open dropzone)}}
          ($ DataGridPremium
             (merge {;; Reinitialize the Data grid when switching between Assets and Fonts,
                     ;; the sorting and tree state etc. have to be reset.
                     :key (str asset-type)
                     :columns (if font-view
                                font-columns
                                (asset-columns asset-type))
                     :rows (to-array (or value []))
                     :data-testid "assetsTable"
                     :getRowId (fn [row]
                                 (str (or (:asset/id row)
                                          (:asset-tree/id row))))
                     :loading (:pending tree)
                     :disableRowSelectionOnClick true
                     :onRowClick on-row-click
                     :initialState #js {;; Default filter to hide the archived items
                                        :filter #js {:filterModel #js {:items #js [#js {:id "status"
                                                                                        :field "status"
                                                                                        :operator "isAnyOf"
                                                                                        :value #js ["false"]}]
                                                                       :logicOperator (.-And GridLogicOperator)}}}
                     :slots #js {:toolbar Toolbar
                                 :cell table/CellSlot
                                 :filterPanelAddIcon filter-panel/AddIconSlot
                                 :filterPanelRemoveAllIcon filter-panel/RemoveAllIconSlot
                                 :moreActionsIcon table/MoreActionIconSlot
                                 :noRowsOverlay table/NoRowsOverlaySlot
                                 :openFilterButtonIcon filter-panel/OpenFilterIconSlot
                                 :row (partial table/RowSlot (partial table/get-asset-name-for-test-id asset-type))}
                     :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                                     :toolbar #js {:asset-type asset-type
                                                   :quick-filter-props {:inputProps #js {:data-testid "searchInput"}}}
                                     :filterPanel #js {:data-testid "moreButtonMenu"
                                                       :filterFormProps #js {:data-testid "filterForm"
                                                                             :columnInputProps #js {:data-testid "columnSelect"}
                                                                             :operatorInputProps #js {:data-testid "operatorSelect"}
                                                                             :valueInputProps #js {:data-testid "valueSelect"}}}
                                     :noResultsOverlay #js {:data-testid "tableMessage"}}
                     :localeText #js {:toolbarQuickFilterPlaceholder "Search in folder..."}
                     :disableColumnSelector true
                     :disableDensitySelector true}
                    (when font-view
                      (fonts-grid-props)))))
       (when (and drop-active
                  (seq value))
         ($ grid-drop-overlay {:asset-type asset-type})))))
